<template>
<div class="calculate">
  <div class="calculate-body">
    <header class="calculate-body__header">
      <div class="title" v-if="calculateStatus === 1">
        Калькулятор ремонта
      </div>
      <span class="back" v-else-if="calculateStatus === 2" @click="minusCalc ()">
        <img src="../../public/static/icons/arrow-back.svg" alt="">
        Назад к выбору стиля
      </span>
      <span class="back" v-else-if="calculateStatus === 3" @click="minusCalc ()">
        <img src="../../public/static/icons/arrow-back.svg" alt="">
        Назад к параметрам
      </span>
      <button class="close" @click="closeCalc ()"><span></span></button>
    </header>
   <form class="calculate-body__middle">
     <div class="calculate-body__step calculate-body__step_first" v-if="calculateStatus === 1">
       <div class="row">
         <div class="col">
           <input type="radio" id="style_1" name="style" value="10000" v-model.number="calculateParameters.style">
           <label for="style_1" class="col-img">
             <picture>
               <source srcset="../../public/static/images/calc/1.webp">
               <img src="../../public/static/images/calc/1.jpg" alt="">
             </picture>
           </label>
           <div class="col-text">
             <span>Минимализм</span>
           </div>
         </div>
         <div class="col">
           <input type="radio" id="style_2" name="style" value="20000" v-model.number="calculateParameters.style">
           <label for="style_2" class="col-img">
             <picture>
               <source srcset="../../public/static/images/calc/2.webp">
               <img src="../../public/static/images/calc/2.jpg" alt="">
             </picture>
           </label>
           <div class="col-text">
             <span>Скандинавский стиль</span>
           </div>
         </div>
         <div class="col">
           <input type="radio" id="style_3" name="style" value="30000" v-model.number="calculateParameters.style">
           <label for="style_3" class="col-img">
             <picture>
               <source srcset="../../public/static/images/calc/3.webp">
               <img src="../../public/static/images/calc/3.jpg" alt="">
             </picture>
           </label>
           <div class="col-text">
             <span>Стиль Лофт</span>
           </div>
         </div>
       </div>
     </div>
     <div class="calculate-body__step calculate-body__step_second" v-if="calculateStatus === 2">
       <div class="row">
         <div class="col-4">
           <div v-if="calculateParameters.style === 10000">
             <picture>
               <source srcset="../../public/static/images/calc/1.webp">
               <img src="../../public/static/images/calc/1.jpg" alt="">
             </picture>
               </div>
           <div v-if="calculateParameters.style === 20000">
             <picture>
               <source srcset="../../public/static/images/calc/2.webp">
               <img src="../../public/static/images/calc/2.jpg" alt="">
             </picture>
           </div>
           <div v-if="calculateParameters.style === 30000">
             <picture>
               <source srcset="../../public/static/images/calc/3.webp">
               <img src="../../public/static/images/calc/3.jpg" alt="">
             </picture>
           </div>
           <div class="col-4__bottom">
             Введите данные о квартире, чтобы уточнить стоимость
           </div>
         </div>
         <div class="col-6">
           <div class="col-6__body">
             <div class="input-group">
               <label for="area" class="text-label">Площадь</label>
               <input type="text" id="area" placeholder="0 м²" v-model.number="calculateParameters.area">
             </div>
             <div class="input-group">
               <label for="height" class="text-label">Высота потолков</label>
               <input type="text" id="height" placeholder="0 м" v-model.number="calculateParameters.height">
             </div>
             <div class="input-group">
               <label for="areaSecond" class="text-label">Площадь санузла</label>
               <input type="text" id="areaSecond" placeholder="0 м²" v-model.number="calculateParameters.areaSecond">
             </div>
             <div class="color-body">
               <div class="input-group input-group_color">
                 <p class="text-label">Отделка стен</p>
                 <input type="radio" id="wallColor_1" value="5000" name="wallColor" v-model.number="calculateParameters.wallColor">
                 <label for="wallColor_1">
                   <span class="preview preview-1"></span>
                   Светло-серый
                 </label>
                 <input type="radio" id="wallColor_2" value="4000" name="wallColor" v-model.number="calculateParameters.wallColor">
                 <label for="wallColor_2">
                   <span class="preview preview-2"></span>
                   Светло-бежевый
                 </label>
                 <input type="radio" id="wallColor_3" value="7000" name="wallColor" v-model.number="calculateParameters.wallColor">
                 <label for="wallColor_3">
                   <span class="preview preview-3"></span>
                   Темно-серый
                 </label>
                 <input type="radio" id="wallColor_4" value="3000" name="wallColor" v-model.number="calculateParameters.wallColor">
                 <label for="wallColor_4">
                   <span class="preview preview-4"></span>
                   Темно-розовый
                 </label>
               </div>
               <div class="input-group input-group_color">
                 <p class="text-label">Пол</p>
                 <input type="radio" id="floorColor_1" value="5000" name="floorColor" v-model.number="calculateParameters.floorColor">
                 <label for="floorColor_1">
                   <span class="preview preview-5"></span>
                   Светлый ламинат
                 </label>
                 <input type="radio" id="floorColor_2" value="4000" name="floorColor" v-model.number="calculateParameters.floorColor">
                 <label for="floorColor_2">
                   <span class="preview preview-6"></span>
                   Наливной пол
                 </label>
                 <input type="radio" id="floorColor_3" value="7000" name="floorColor" v-model.number="calculateParameters.floorColor">
                 <label for="floorColor_3">
                   <span class="preview preview-7"></span>
                   Паркетная доска
                 </label>
               </div>
             </div>
           </div>
         </div>
       </div>
     </div>
     <div class="calculate-body__step calculate-body__step_third" v-if="calculateStatus === 3">
       <div class="row">
         <div class="col-4">
           <p>Тёплый пол на кухне, дополнительный санузел, шторы на окна и другие опции вы сможете выбрать у нас в офисе</p>
         </div>
       </div>
     </div>
   </form>
    <footer class="calculate-body__footer">
      <div class="price">
        <span>Стоимость ремонта: от {{ calculateResult }} руб</span>
      </div>
      <div class="reset" v-if="calculateStatus > 1">
        <span @click="resetPes ()">Сбросить все</span>
      </div>
      <div class="btn">
        <button class="button button_small" v-if="calculateStatus === 3" @click="closeCalc (); quizPlus ()">Оставить заявку</button>
        <button class="button button_small" @click="plusCalc ()" v-else><span v-if="calculateStatus === 1">Далее</span><span v-if="calculateStatus === 2">Дополнительные опции</span></button>
      </div>
    </footer>
  </div>
  <div class="calculate-bg"></div>
</div>
</template>

<script>
import {mapGetters, mapActions} from 'vuex'
export default {
  name: 'Calculate',
  components: {},
  computed: {
    ...mapGetters([
      'calculateStatus',
      'calculateResult',
      'calculateParameters'
    ])
  },
  methods: {
    ...mapActions([
      'calcStatusPlus',
      'calcStatusMinus',
      'resultCalc',
      'resetResult',
      'close',
      'plusQuiz'
    ]),
    plusCalc () {
      this.calcStatusPlus()
    },
    minusCalc () {
      this.calcStatusMinus()
    },
    getResult () {
      this.resultCalc()
    },
    resetPes () {
      this.resetResult()
    },
    closeCalc () {
      this.close()
    },
    quizPlus () {
      this.plusQuiz()
    }
  },
  mounted() {
    setInterval(() => {
      this.getResult ()
    }, 100)
  }
}
</script>

<style scoped lang='scss'>
.calculate {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  z-index: 30;

  &-body {
    position: absolute;
    top: 50%;
    left: 50%;
    z-index: 1;
    width: 80vw;
    min-width: 300px;
    height: 80vh;
    min-height: 300px;
    background-color: #fff;
    transform: translate(-50%,-50%);
    display: flex;
    flex-direction: column;
    padding: 50px 100px;
    @media (max-width: 1199.98px) {
      width: 100%;
      height: 100%;
      overflow: scroll;
      padding: 30px 10px;
    }
    .close {
      position: relative;
      top: 0;
      right: 0;
      width: 30px;
      height: 30px;
      padding: 0;
      span {
        position: relative;
        width: 100%;
        height: 100%;
        content: '';
        display: block;
        top: 0;
        right: 0;
        &:after, &:before {
          position: absolute;
          width: 30px;
          height: 2px;
          content: '';
          background-color: #000000;
          top: 50%;
          right: 0;
        }
        &:after {
          transform: rotate(45deg);
        }
        &:before {
          transform: rotate(-45deg);
        }
      }
    }
    &__header {
      margin-bottom: 20px;
      display: flex;
      justify-content: space-between;
      .title {
        font-size: 3rem;
        @media (max-width: 1399.98px) {
          font-size: 2rem;
        }
      }
      .back {
        font-size: 3rem;
        display: flex;
        align-items: center;
        cursor: pointer;
        @media (max-width: 1399.98px) {
          font-size: 2rem;
        }
        img {
          margin-right: 20px;
          width: 40px;
          height: auto;
          object-fit: contain;
          object-position: center;
          @media (max-width: 1399.98px) {
            width: 30px;
          }
        }
      }
    }
    &__middle {
      flex: 1 1 auto;
    }
    &__footer {
      display: flex;
      align-items: center;
      margin-top: 20px;
      @media (max-width: 1199.98px) {
        flex-wrap: wrap;
      }
      .price {
        flex: 1 1 auto;
        font-size: 2rem;
        @media (max-width: 1399.98px) {
          font-size: 1.6rem;
        }
        @media (max-width: 575.98px) {
          margin-right: 40px;
        }
      }
      .reset {
        margin-right: 40px;
        font-size: 2rem;
        cursor: pointer;
        @media (max-width: 1399.98px) {
          font-size: 1.6rem;
        }
      }
      .btn {
        button {
          padding: 20px 30px;
          font-size: 1.6rem;
          font-weight: 300;
          min-width: 400px;
          @media (max-width: 575.98px) {
            padding: 10px 15px;
            flex: 1 1 100%;
            min-width: 100%;
            margin-top: 10px;
            margin-bottom: 40px;
          }
        }
        @media (max-width: 575.98px) {
          flex: 1 1 100%;
          min-width: 100%;
        }
      }
    }
    &__step {
      height: 100%;
      position: relative;
      &_first {
        .row {
          display: flex;
          flex-wrap: wrap;
          height: 100%;
          position: relative;
          .col {
            display: flex;
            flex-direction: column;
            flex: 0 0 33.333%;
            max-width: 33.333%;
            height: 100%;
            overflow: hidden;
            box-sizing: border-box;
            @media (max-width: 1199.98px) {
              flex: 0 0 100%;
              max-width: 100%;
              height: 300px;
            }
            &-img {
              overflow: hidden;
              width: 100%;
              position: relative;
              display: flex;
              flex: 1 1 auto;
              img {
                object-fit: cover;
                object-position: center;
                height: 100%;
                width: 100%;
              }
            }
            &-text {
              text-align: center;
              font-weight: 300;
              font-size: 1.6rem;
              color: #333333;
              margin: 10px 0 20px 0;
            }
            input[type="radio"] {
              display: none;
              +label {
                cursor: pointer;
                transition: .1s linear all;
              }
              &:checked+label {
                border: 15px solid #FAFF09;
                box-sizing: border-box;
                @media (max-width: 1199.98px) {
                  border: 5px solid #FAFF09;
                }
              }
            }
          }
        }
      }
      &_second {
        .row {
          display: flex;
          flex-wrap: wrap;
          height: 100%;
          position: relative;
          margin: 0 -20px;
          .col-4 {
            flex: 0 0 40%;
            max-width: 40%;
            box-sizing: border-box;
            display: flex;
            flex-direction: column;
            height: 100%;
            overflow: hidden;
            width: 100%;
            position: relative;
            padding: 0 20px;
            @media (max-width: 1199.98px) {
              flex: 0 0 100%;
              max-width: 100%;
              height: 300px;
            }
            &__bottom {
              font-weight: 500;
              font-size: 1.6rem;
              color: #333333;
              margin-top: 20px;
              @media (max-width: 575.98px) {
                margin-bottom: 20px;
              }
            }
            div:first-child {
              overflow: hidden;
              width: 100%;
              position: relative;
              display: flex;
              flex: 1 1 auto;
              img {
                object-fit: cover;
                object-position: center;
                height: 100%;
                width: 100%;
              }
            }
          }
          .col-6 {
            flex: 0 0 60%;
            max-width: 60%;
            box-sizing: border-box;
            display: flex;
            flex-direction: column;
            height: 100%;
            overflow: hidden;
            padding: 0 20px;
            @media (max-width: 1199.98px) {
              flex: 0 0 100%;
              max-width: 100%;
              height: auto;
            }
            &__body {
              display: flex;
              flex-wrap: wrap;
              margin: 0 -10px;
              .color-body {
                display: flex;
                flex-wrap: wrap;
              }
            }
            .input-group {
              display: flex;
              flex-direction: column;
              flex: 0 0 50%;
              max-width: 50%;
              padding: 0 10px;
              margin-bottom: 20px;
              @media (max-width: 575.98px) {
                flex: 0 0 100%;
                max-width: 100%;
              }
              input[type="text"] {
                border: 1px solid #E0E0E0;
                box-sizing: border-box;
                font-weight: 300;
                font-size: 1.6rem;
                color: #0E0E0E;
                width: 100%;
                padding: 15px 20px;
                height: auto;
                &::placeholder {
                  font-weight: 200;
                  font-size: 1.6rem;
                  color: #4F4F4F;
                }
              }
              &_color {
                flex-direction: row;
                flex-wrap: wrap;
                margin: 0 -4.5px;
                p {
                  flex: 0 0 100%;
                  max-width: 100%;
                  padding: 0 4.5px;
                }
              }
              .text-label {
                font-weight: 300;
                font-size: 2rem;
                color: #4F4F4F;
                margin-bottom: 5px;
              }
              input[type="radio"] {
                display: none;
                &+label {
                  font-weight: 300;
                  font-size: 1.2rem;
                  color: #333333;
                  display: flex;
                  flex: 0 0 50%;
                  max-width: 50%;
                  box-sizing: border-box;
                  align-items: center;
                  padding: 4.5px;
                  .preview {
                    width: 40px;
                    height: 40px;
                    margin-right: 10px;
                    &-1 {
                      background: #F2F2F2;
                    }
                    &-2 {
                      background: #F9F3E6;
                    }
                    &-3 {
                      background: #BDBDBD;
                    }
                    &-4 {
                      background: #E7D0D0;
                    }
                    &-5 {
                      background: #F2F2F2;
                    }
                    &-6 {
                      background: #F2F2F2;
                    }
                    &-7 {
                      background: #F2F2F2;
                    }
                  }
                }
                &:checked+label .preview{
                  background-image: url("../../public/static/icons/check.svg");
                  background-repeat: no-repeat;
                  background-position: center;
                  background-size: 15px;
                }
              }
            }
          }
        }
      }
      &_third {
        .row {
          display: flex;
          flex-wrap: wrap;
          height: 100%;
          position: relative;
          margin: 0 -20px;
          .col-4 {
            flex: 0 0 40%;
            max-width: 40%;
            box-sizing: border-box;
            display: flex;
            flex-direction: column;
            height: 100%;
            overflow: hidden;
            width: 100%;
            position: relative;
            padding: 0 20px;
            font-weight: 300;
            font-size: 2.4rem;
            color: #4F4F4F;
            @media (max-width: 1199.98px) {
              flex: 0 0 100%;
              max-width: 100%;
            }
          }
        }
      }
    }
  }
  &-bg {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    width: 100%;
    height: 100%;
    background-color: #000;
    opacity: .6;
  }
}
</style>
